<div class="flex flex-center">
  <lib-back-button></lib-back-button>
  <nav class="breadcrumb">
    <ul>
      @for (link of links(); track $index) {
        <li>
          <a mat-button [routerLink]="link.route" [queryParams]="link.queryParams" [replaceUrl]="true">{{ link.label }}</a>
        </li>
      }
    </ul>
  </nav>
</div>
